var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 248,
    viewBox: "0 0 730 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05887 0 18 0H266C275.941 0 284 8.05887 284 18V57.8039C284 68.8496 275.046 77.8039 264 77.8039H252.605C235.15 77.8039 221 91.9539 221 109.409C221 119.676 212.676 128 202.409 128H18C8.05887 128 0 119.941 0 110V18Z",
    fill: "#151521"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 108,
    r: 25,
    fill: "#151521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253 117.969L253.013 117.954",
    stroke: "#C1B5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.615 116.533V121.369C261.615 121.481 261.593 121.592 261.55 121.695C261.506 121.799 261.443 121.893 261.363 121.972C261.283 122.051 261.188 122.114 261.083 122.157C260.979 122.2 260.867 122.222 260.754 122.222H245.246C245.133 122.222 245.021 122.2 244.916 122.157C244.812 122.114 244.717 122.051 244.637 121.972C244.557 121.893 244.493 121.799 244.45 121.695C244.407 121.592 244.385 121.481 244.385 121.369V116.533M261.615 99.4666V94.631C261.615 94.4047 261.525 94.1877 261.363 94.0276C261.201 93.8676 260.982 93.7777 260.754 93.7777H245.246C245.018 93.7777 244.798 93.8676 244.637 94.0276C244.475 94.1877 244.385 94.4047 244.385 94.631V99.4666",
    stroke: "#C1B5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258.026 103.022L263.052 108L258.026 112.978M247.975 103.022L242.949 108L247.975 112.978",
    stroke: "#C1B5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.44 97C285.44 86.5066 293.947 78 304.44 78H710C720.493 78 729 86.5066 729 97V228C729 238.493 720.493 247 710 247H244C233.507 247 225 238.493 225 228V160C225 149.507 233.507 141 244 141H250.44C269.77 141 285.44 125.33 285.44 106V97Z",
    stroke: "#C1B5FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.c5048a41ae854b25d9aaf6a6c82cca91.svg";
export { ForwardRef as ReactComponent };